module.exports = "<title>\n  {{seoTitle}}\n</title>"